<template>
  <div class="invoice-detail">
    <div class="page-box">
      <div class="invoice-statu flex-between-center">
        <div class="title">
          <span>销售方名称：{{ invoiceData.supplierCompany }}</span>
          <span
            v-if="
              invoiceData.orderInvoiceExtendVO &&
              invoiceData.orderInvoiceExtendVO.electronicInvoiceStatus === 3
            "
            class="reject-text"
            >开票失败原因：{{
              invoiceData.orderInvoiceExtendVO.resultMessage
            }}</span
          >
        </div>
        <el-button
          v-if="invoiceData.invoiceStatus === 24"
          type="primary"
          @click="showVerifyDialog"
          >开票信息提交</el-button
        >
        <el-button
          v-if="
            invoiceData.orderInvoiceExtendVO &&
            invoiceData.orderInvoiceExtendVO.electronicInvoiceStatus === 2
          "
          type="primary"
          @click="downInvoice"
          >下载发票</el-button
        >
        <el-button
          v-if="
            invoiceData.orderInvoiceExtendVO &&
            invoiceData.orderInvoiceExtendVO.electronicInvoiceStatus === 3
          "
          type="primary"
          @click="resetInvoice"
          >重新开票</el-button
        >
      </div>
    </div>

    <div class="page-box">
      <div class="title">发票信息</div>
      <div class="content">
        <el-row class="row-line">
          <el-col :span="12"
            >开票方式：{{
              invoiceData.invoiceMode === 1 ? '一票制' : '两票制'
            }}</el-col
          >
          <el-col :span="12"
            >开票形式：{{
              invoiceData.electronicInvoiceFlag === 1 ? '电子发票' : '纸质发票'
            }}</el-col
          >
        </el-row>
        <el-row class="row-line">
          <el-col :span="12"
            >发票类型：{{ invoiceData.invoiceTypeDesc }}</el-col
          >
          <el-col :span="12"
            >开票金额：
            <span v-if="invoiceData.invoiceMode == 1" class="red"
              >¥ {{ invoiceData.totalAmount }} 元</span
            >
            <span v-else>
              <span
                >货款金额:
                <span class="red">{{
                  invoiceData.productAmount
                    ? `¥ ${invoiceData.productAmount} 元`
                    : ''
                }}</span></span
              >
              <span
                v-if="invoiceData.invoiceMode === 2"
                style="margin-left: 10px"
                >运费金额:
                <span class="red">
                  {{
                    invoiceData.shipmentTotalAmount
                      ? `¥ ${invoiceData.shipmentTotalAmount} 元`
                      : '0 元'
                  }}
                </span>
              </span>
            </span></el-col
          >
        </el-row>
      </div>
    </div>

    <div class="page-box">
      <div class="title">发票抬头</div>
      <div class="content">
        <el-row class="row-line">
          <el-col :span="12">发票抬头：{{ invoiceData.customer }}</el-col>
          <el-col :span="12">购方电话：{{ invoiceData.telephone }}</el-col>
        </el-row>
        <el-row class="row-line">
          <el-col :span="12"
            >购方地址：{{ invoiceData.registerAddress }}</el-col
          >
          <el-col :span="12">账户开户行：{{ invoiceData.bank }}</el-col>
        </el-row>
        <el-row class="row-line">
          <el-col :span="12"
            >购方税号：{{ invoiceData.identificationNumber }}</el-col
          >
          <el-col :span="12"
            >购方银行账号：{{ invoiceData.bankAccount }}</el-col
          >
        </el-row>
      </div>
    </div>

    <div class="page-box">
      <el-table
        ref="tableData"
        :data="tableData"
        style="width: 100%"
        row-key="orderId"
        :expand-row-keys="expands"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        @expand-change="expandChange"
        @row-click="rowClick"
      >
        <el-table-column label="订单编号" prop="orderNo"> </el-table-column>
        <el-table-column label="货款金额（元）" prop="productCost">
        </el-table-column>
        <el-table-column label="运费金额（元）" prop="shippingCost">
        </el-table-column>
        <el-table-column label="下单时间" prop="submitTime"> </el-table-column>
        <el-table-column label="操作" prop="submitTime">
          <template #default="slotScope">
            <span class="del-btn" @click="goInfo(slotScope.row)"> 查看 </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productData.pageNum"
          :total="productData.total"
          :page-size.sync="productData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <div class="page-box">
      <div class="content-wrapper">
        <div class="title-box">发票信息</div>
        <div class="detail-box">
          <div>电子发票文件：</div>
          <div class="attach-wrapper flex" style="flex-wrap: wrap">
            <div class="attach-box" :class="[fileIndex === 3 ? '' : 'margin-r20',fileIndex === 0 ? 'margin-b10' :'']"
                 v-for="(item,fileIndex) in invoiceData.attachVOs" :key="fileIndex">
              <div class="attach-left">
                <div @click="downloadFile(item)">
                  <eui-tooltip-over class="file-name" :tooltipStyle="{ 'width': '180px' }" :content="item.name">
                    <span>{{item.name}}</span>
                  </eui-tooltip-over>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <el-button type="primary" @click="closePage">关闭页面</el-button>

    <el-drawer
      :visible.sync="dialog"
      direction="rtl"
      destroy-on-close="true"
      show-close="false"
      custom-class="demo-drawer"
      wrapper-closable="false"
      size="900px"
      :append-to-body="true"
      :modal-append-to-body="false"
      :with-header="false"
    >
      <div class="drawer-head">
        <div>订单详情</div>
        <div>
          <img src="" alt="" />
        </div>
      </div>
      <div class="drawer-box">
        <div class="drawer-info">
          <div class="single-box">
            <div class="single-box-pram">订单编号:</div>
            <div class="single-box-content">{{ drawerInfo.orderNo }}</div>
          </div>
          <div class="single-box">
            <div class="single-box-pram">货款金额:</div>
            <div class="single-box-content">{{ drawerInfo.needPay }}元</div>
          </div>
          <div class="single-box">
            <div class="single-box-pram">运费金额:</div>
            <div class="single-box-content">
              {{ drawerInfo.shippingCost }}元
            </div>
          </div>
          <div class="single-box">
            <div class="single-box-pram">下单时间:</div>
            <div class="single-box-content">{{ drawerInfo.submitTime }}</div>
          </div>
        </div>
        <div class="table-box">
          <el-table
            :data="orderTableData"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            border
          >
            <el-table-column label="序号" width="60px" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="商品名称" min-width="150">
              <template slot-scope="scope">
                <div style="text-align: left">
                  {{ scope.row.productName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品规格属性" prop="displaySkuOptions">
            </el-table-column>
            <el-table-column label="商品单价（元）" prop="price">
            </el-table-column>
            <el-table-column label="采购数量" prop="quantity">
            </el-table-column>
            <!-- <el-table-column label="税率（%）" prop="salesTaxRate">
            </el-table-column> -->
            <!-- <el-table-column label="税费（元）" prop="salesTax">
              <template slot-scope="scope">{{
                ((scope.row.subtotal * scope.row.salesTaxRate) / 100).toFixed(2)
              }}</template>
            </el-table-column> -->
            <el-table-column label="小计（元）" prop="subtotal">
            </el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination
              :pager-count="5"
              :page-sizes="[10, 20, 30]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="drawerData.pageNum"
              :total="drawerData.total"
              :page-size.sync="drawerData.pageSize"
              prev-text="上一页"
              next-text="下一页"
              @size-change="handleDrawerSizeChange"
              @current-change="handleDrawerCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
    <verify-dialog
      :verify-visible="verifyVisible"
      @openInvoice="openInvoice"
    ></verify-dialog>
    <copy-dialog
      :copy-visible="copyVisible"
      :invoice-data="invoiceData"
    ></copy-dialog>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import invoiceApi from '@/modules/projectA/api/electronicInvoice';
import VerifyDialog from './verifyDialog.vue';
import CopyDialog from './copyDialog.vue';

export default {
  components: {
    VerifyDialog,
    CopyDialog,
  },
  props: {},
  data() {
    return {
      address: '',
      expands: [],
      tableData: [],
      radio: '2',
      purchaseCompanyId: '',
      invoiceType: '',
      orderInvoiceListId: '',
      invoiceData: {},
      orderTableData: [],
      productData: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      drawerData: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      dialog: false,
      loading: false,
      drawerInfo: {},
      verifyVisible: false,
      copyVisible: false,
    };
  },
  mounted() {
    this.orderInvoiceListId = this.$route.query.orderInvoiceListId;
    this.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getDetail();
    this.orderList();
  },
  methods: {
    //下载附件
    downloadFile(val) {
      const url = val.url
      const filename = val.name;
      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = e => {
        // 会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      }
      x.send()
    },
    // 商品
    async grtListSupplierSku(orderId) {
      api
        .grtListSupplierSku({
          orderId,
          purchaseCompanyId: this.invoiceData.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code === '200') {
            this.orderTableData = res.data?.records;
          }
        });
    },
    rowClick(row) {
      this.$refs.tableData.toggleRowExpansion(row);
    },
    expandChange(row, expandedRows) {
      const { orderId } = row;

      if (!orderId) {
        return;
      }

      this.grtListSupplierSku(orderId);
      if (expandedRows.length > 1) {
        expandedRows.shift();
      }
      // 只展开一个
      const that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.orderId);
        }
      } else {
        that.expands = [];
      }
    },
    getDetail() {
      api
        .detail({
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
          pageNum: this.productData.pageNum,
          pageSize: this.productData.pageSize,
        })
        .then((res) => {
          if (res.code === '200') {
            this.invoiceData = res.data;
            this.purchaseCompanyId = res.data.purchaseCompanyId;
            if (this.invoiceData?.sendTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[1].eventTime = this.invoiceData.receiveTime;
              this.transForm[2].eventTime = this.invoiceData.sendTime;
              this.transForm.forEach((item) => {
                item.light = true;
              });
            } else if (this.invoiceData?.receiveTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[0].light = true;
              this.transForm[1].eventTime = this.invoiceData.receiveTime;
              this.transForm[1].light = true;
              this.transForm[2].light = true;
            } else if (this.invoiceData?.createTime) {
              this.transForm[0].eventTime = this.invoiceData.createTime;
              this.transForm[0].light = true;
              this.transForm[1].light = true;
            }
            this.transForm = [...this.transForm];

            switch (this.invoiceData.invoiceMode) {
              case 1:
                this.invoiceType = '一票制';
                break;
              case 2:
                this.invoiceType = '两票制';
                break;
              case 3:
                this.invoiceType = '一票制、两票制';
                break;
              default:
                this.invoiceType = '';
                break;
            }
          }
        });
    },
    orderList() {
      api
        .orderList({
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
          pageNum: this.drawerData.pageNum,
          pageSize: this.drawerData.pageSize,
        })
        .then((res) => {
          if (res.code === '200') {
            this.tableData = res.data.records;
            this.drawerData.total = res.data.total;
          }
        });
    },
    closePage() {
      this.$router.back();
    },
    showVerifyDialog() {
      this.verifyVisible = true;
    },
    async openInvoice() {
      try {
        const query = {
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
        };
        console.log(query);
        const info = await invoiceApi.applyElectronicInvoice(query);
        if (info.success) {
          this.$message({
            type: 'success',
            message: '开票成功!',
          });
          this.copyVisible = true;
          setTimeout(() => {
            this.verifyVisible = false;
          }, 200);
          this.getDetail();
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      this.productData.pageNum = val;
    },
    handleSizeChange(val) {
      this.productData.pageNum = 1;
      this.productData.pageSize = val;
    },
    goInfo(data) {
      console.log(data);
      this.drawerInfo = data;
      api
        .grtListSupplierSku({
          orderId: data.orderId,
          purchaseCompanyId: this.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code === '200') {
            this.orderTableData = res.data?.records;
            this.dialog = true;
          }
        });
    },

    handleDrawerSizeChange(val) {
      this.drawerData.pageNum = val;
    },
    handleDrawerCurrentChange(val) {
      this.drawerData.pageNum = 1;
      this.drawerData.pageSize = val;
    },
    resetInvoice() {},
    downInvoice() {
      window.open(this.invoiceData.orderInvoiceExtendVO.invoiceUrl);
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-detail {
  .content-wrapper {
    .detail-box {
      padding: 20px;
      font-size: 14px;
      color: #333;

      div {
        margin-bottom: 14px;
      }
    }
  }

  .attach-wrapper {
    .attach-box {
      width: 206px;
      height: 60px;
      padding: 6px 10px 10px 10px;
      background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);
      margin-bottom: 6px;

      .attach-left {
        .margin-t4 {
          margin-top: 4px;
        }
      }

      .file-name {
        color: #0064C8;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
  .page-box {
    background: #fff;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    .invoice-statu {
      .reject-text {
        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        color: #f0250f;
        margin-left: 20px;
      }
    }
    .flex-between-center {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .title {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
    }
    .content {
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
      .row-line {
        margin-bottom: 20px;
      }

      .row-line:nth-last-child(1) {
        margin-bottom: 0px;
      }
    }
  }
  .el-drawer {
    ::v-deep .el-drawer {
      z-index: 3000;
    }
  }
}

.drawer-head {
  height: 40px;
  line-height: 40px;
  background: #f5f5f5;
  padding: 0 20px;
}

.drawer-box {
  padding: 20px;
  .drawer-info {
  }
  .table-box {
    margin-top: 20px;
  }
  .drawer-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    color: #333;
    .single-box {
      .single-box-pram {
        margin-bottom: 10px;
      }
      .single-box-content {
        font-weight: 500;
      }
    }
  }
}
</style>
